import { render } from "./ToolsPage.vue?vue&type=template&id=478a9cb9&scoped=true"
import script from "./ToolsPage.vue?vue&type=script&lang=js"
export * from "./ToolsPage.vue?vue&type=script&lang=js"

import "./ToolsPage.vue?vue&type=style&index=0&id=478a9cb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478a9cb9"]])

export default __exports__